<template>
<label :class="_class">
    <slot></slot>
    <span></span>
</label>
</template>

<script>
export default {
    props: {
        type: {
            default: 'checkbox'
        }
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('kt-'+this.type)

            return _class
        }
    }
}
</script>